import { lazy } from 'react';

import { ApprovalList, ApprovalDetails } from './approval';

const Analytics = lazy(() => import('./analytics'));

export { Analytics, ApprovalList, ApprovalDetails };
